// quill return empty text as <p><br></p for each line e.g. 5 empty lines:
// <p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>
export function isMarkupWithoutText(text: string): boolean {
  const tagRegex = /(<([^>]+)>)/gi;

  return !text.replace(tagRegex, '').trim().length;
}
